import Cookies from "js-cookie";
import axios from "axios";
import qs from 'qs'
import store from '@/store';
import Vue from 'vue';

const RongIMLib = require('@rongcloud/imlib-next')

var browser = {
    versions: function () {
        var u = navigator.userAgent;
        return { //移动终端浏览器版本信息
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
        };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

/**
 * [获取URL中的参数名及参数值的集合]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&username=张三
 */
export function GetParams(urlStr) {//两种方式，输入链接获取或当前链接获取
    if (typeof urlStr == "undefined") {
        var url = decodeURI(location.search); //获取url中"?"符后的字符串
    } else {
        if (urlStr.split("?").length > 1) {   // 路径后面拼接的有参数
            url = "?" + urlStr.split("?")[1];
        } else {
            url = urlStr
        }
    }
    var theRequest
    if (url.indexOf("?") != -1) {
        theRequest = new Object();
        var str = url.substr(1);//去掉问号，问号为第一个字符
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    } else {
        theRequest = ''
    }
    return theRequest;
}

// 判断是否大于当前时间
/**
 *  true 开始时间大于当前时间
 * @param startTime
 * @returns {boolean}
 */
export function isMoreCurrentTime(startTime) {
    let dateBegin
    if (browser.versions.mobile && browser.versions.ios) {   // 移动端且为IOS手机
        let time = startTime.replace(/-/g, '/')
        dateBegin = new Date(time)
    } else {
        dateBegin = new Date(startTime)
    }
    let dateEnd = new Date();//获取当前时间
    let dateDiff = dateBegin.getTime() - dateEnd.getTime();//时间差的毫秒数
    if (dateDiff > 0) {
        return true
    } else {
        return false
    }
}

// 判断结束时间是否大于开始时间
/**
 * true 结束时间大于开始时间
 * @param startTime
 * @param endTime
 * @returns {boolean}
 */
export function isMoreStartTime(startTime, endTime) {
    let dateBegin
    let dateEnd
    if (browser.versions.mobile && browser.versions.ios) {   // 移动端且为IOS手机
        let time = startTime.replace(/-/g, '/')
        dateBegin = new Date(time)
        let time1 = endTime.replace(/-/g, '/')
        dateEnd = new Date(time1)
    } else {
        dateBegin = new Date(startTime)
        dateEnd = new Date(endTime)
    }
    let dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
    if (dateDiff > 0) {
        return true
    } else {
        return false
    }
}

// 判断当前时间和开始时间相差多少时分秒
export function getTimeDiffer(startTime) {
    var timeObj = {}
    var dateBegin
    if (browser.versions.mobile && browser.versions.ios) {   // 移动端且为IOS手机
        let time = startTime.replace(/-/g, '/')
        dateBegin = new Date(time)
    } else {
        dateBegin = new Date(startTime)
    }
    var dateEnd = new Date();//获取当前时间
    var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
    //计算相差天数
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    //计算相差小时数
    var leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    var differHours = dayDiff * 24 + hours
    var differTime = '00:00:00'
    if (differHours >= 1) {
        timeObj.isMoreOne = true
    } else {
        timeObj.isMoreOne = false
    }
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)
    // console.log(" 相差 "+dayDiff+"天 "+hours+"小时 "+minutes+" 分钟"+seconds+" 秒")
    // console.log(dateDiff+"时间差的毫秒数",dayDiff+"计算出相差天数",leave1+"计算天数后剩余的毫秒数",hours+"计算出小时数",minutes+"计算相差分钟数",seconds+"计算相差秒数");
    // 返回相差的时分秒
    differHours = differHours < 10 ? '0' + differHours : differHours
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds
    differTime = differHours + ':' + minutes + ':' + seconds
    timeObj.differTime = differTime
    return timeObj
}

// 判断结束时间和开始时间相差多少时分秒
export function getStartEndDiffer(startTime, endTime) {
    let timeObj = {}
    let dateBegin
    let dateEnd
    if (browser.versions.mobile && browser.versions.ios) {   // 移动端且为IOS手机
        let time = startTime.replace(/-/g, '/')
        let timeEnd = endTime.replace(/-/g, '/')
        dateBegin = new Date(time)
        dateEnd = new Date(timeEnd)
    } else {
        dateBegin = new Date(startTime)
        dateEnd = new Date(endTime)
    }
    let dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
    //计算相差天数
    let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    //计算相差小时数
    let leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    let hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    let differHours = dayDiff * 24 + hours
    let differTime = '00:00:00'
    if (differHours >= 1) {
        timeObj.isMoreOne = true
    } else {
        timeObj.isMoreOne = false
    }
    //计算相差分钟数
    let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    let minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    let leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    let seconds = Math.round(leave3 / 1000)
    // console.log(" 相差 "+dayDiff+"天 "+hours+"小时 "+minutes+" 分钟"+seconds+" 秒")
    // console.log(dateDiff+"时间差的毫秒数",dayDiff+"计算出相差天数",leave1+"计算天数后剩余的毫秒数",hours+"计算出小时数",minutes+"计算相差分钟数",seconds+"计算相差秒数");
    // 返回相差的时分秒
    differHours = differHours < 10 ? '0' + differHours : differHours
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds
    differTime = differHours + ':' + minutes + ':' + seconds
    timeObj.differTime = differTime
    return timeObj
}

// 判断当前时间和开始时间相差多少分秒
export function getMinuteDiffer(startTime) {
    var timeObj = {}
    var dateBegin
    if (browser.versions.mobile && browser.versions.ios) {   // 移动端且为IOS手机
        let time = startTime.replace(/-/g, '/')
        dateBegin = new Date(time)
    } else {
        dateBegin = new Date(startTime)
    }
    var dateEnd = new Date();//获取当前时间
    // var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒
    var dateDiff = dateBegin.getTime() + 5 * 60 * 1000 - dateEnd.getTime()  //时间差的毫秒

    var minutes = Math.floor(dateDiff / (60 * 1000)) //计算相差分钟数
    var leave1 = dateDiff % (60 * 1000)    //计算分钟后剩余的毫秒数
    var seconds = Math.round(leave1 / 1000)
    var differTime = '00:00'
    if (minutes <= 0 && seconds <= 0) {
        timeObj.isMoreFive = true
    } else {
        timeObj.isMoreFive = false
    }
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds
    differTime = minutes + ':' + seconds
    timeObj.differTime = differTime
    return timeObj
}

export function isEmptyStr(s) {
    return s === undefined || s == null || s === '' || s === 'NaN' || (s + '').trim() === '';
}

/**
 * [获取URL中的参数名及参数值的集合]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&username=张三
 */
export function GetRequest(urlStr) {//两种方式，输入链接获取或当前链接获取
    let url = "";
    if (typeof urlStr == "undefined") {
        url = decodeURI(location.search); //获取url中"?"符后的字符串
    } else {
        if (urlStr.split("?").length > 1) {   // 路径后面拼接的有参数
            url = "?" + urlStr.split("?")[1];
            // 处理#号
            if (url.indexOf("#") > -1) {
                url = url.split("#")[0];
            }
        } else {
            url = urlStr
        }
    }
    var theRequest
    if (url.indexOf("?") != -1) {
        theRequest = new Object();
        var str = url.substr(1);//去掉问号，问号为第一个字符
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    } else {
        theRequest = ''
    }
    return theRequest;
}

// 防抖
export function _debounce(fn, delay) {
    var delay1 = delay || 200
    var timer
    return function () {
        var th = this
        var args = arguments
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(function () {
            timer = null
            fn.apply(th, args)
        }, delay1)
    }
}

//节流
export function _throttle(fn, interval) {
    var last
    var timer
    var interval1 = interval || 200
    return function () {
        var th = this
        var args = arguments
        var now = +new Date()
        if (last && now - last < interval) {
            clearTimeout(timer)
            timer = setTimeout(function () {
                last = now
                fn.apply(th, args)
            }, interval1)
        } else {
            last = now
            fn.apply(th, args)
        }
    }
}

// 防止连点
export function _preventDoubleClick(fn) {
    var last
    return function () {
        var th = this
        var args = arguments
        var now = +new Date()
        if (last && now - last < 1000) {
            return
        }
        last = now
        fn.apply(th, args)
    }
}

// 经纬度数值格式

//度转度°分′秒″
export function toDegrees(val) {
    if (typeof (val) == "undefined" || val == "") {
        return "";
    }
    var i = val.indexOf('.');
    var strDu = i < 0 ? val : val.substring(0, i);//获取度
    var strFen = 0;
    var strMiao = 0;
    if (i > 0) {
        strFen = "0" + val.substring(i);
        strFen = strFen * 60 + "";
        i = strFen.indexOf('.');
        if (i > 0) {
            strMiao = "0" + strFen.substring(i);
            strFen = strFen.substring(0, i);//获取分
            strMiao = strMiao * 60 + "";
            i = strMiao.indexOf('.');
            strMiao = strMiao.substring(0, i + 4);//取到小数点后面三位
            strMiao = parseFloat(strMiao).toFixed(2);//精确小数点后面两位
        }
    }
    // return strDu + "," + strFen + "," + strMiao;    // 这里可以修改成你想要的格式例如你可以//    改成这样的：
    // return strDu + "°" + strFen + "'" + strMiao + "\"N";
    return strDu + "°" + strFen + "'";
}

// 根据两地经纬度获取距离
export function space(lat1, lng1, lat2, lng2) {
    console.log(lat1, lng1, lat2, lng2)
    var radLat1 = lat1 * Math.PI / 180.0;
    var radLat2 = lat2 * Math.PI / 180.0;
    var a = radLat1 - radLat2;
    var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137;
    s = Math.round(s * 10000) / 10000;
    return s  // 单位千米
}

// 小数点保留三位
export function toFixedThree(num) {
    return parseFloat(num).toFixed(3);
}

// 姓名脱敏加密
export function encryptName(name) {
    if (name.length === 2) {
        return name.substring(0, 1) + '*'
    } else if (name.length > 2) {
        return name.substring(0, 1) + '**'
    } else {
        return name
    }
}

// 身份证号脱敏加密
export function cardNoDesensitization(cardNo) {
    let cardNoDesensitization = ''
    for (let i = 0; i < cardNo.length; i++) {
        if (i < 4 || i > 13) {
            cardNoDesensitization += cardNo[i]
        } else {
            cardNoDesensitization += '*'
        }
    }
    return cardNoDesensitization
}

// 手机号脱敏加密
export function telDesensitization(tel) {
    let telDesensitization = ''
    if (!tel) {
        return ''
    }
    if (tel.length !== 11) {
        return tel
    }
    for (let i = 0; i < tel.length; i++) {
        if (i < 3 || i > 6) {
            telDesensitization += tel[i]
        } else {
            telDesensitization += '*'
        }
    }
    return telDesensitization
}

// 火星坐标系转84
export function gcj02towgs84(lng, lat) {
    var x_pi = 3.14159265358979324 * 3000.0 / 180.0;
    var x = lng;
    var y = lat;
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
    var lngs = z * Math.cos(theta) + 0.0065;
    var lats = z * Math.sin(theta) + 0.006;
    return [lngs, lats]
}

// 页面跳转
export function jumpTo(path, param) {
    console.log(path);
    if (param && param.constructor === Object && Object.keys(param).length > 0) {
        window.location.href = path + '?' + qs.stringify(param)
    } else {
        window.location.href = path
    }
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
    window.localStorage.removeItem('haderMapType');
    Cookies.remove('jk_community_token')

    // 营商环境
    // store.commit('resetStore')
    window.usrStorage.remove()
    Cookies.remove('token')
    window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = false
}

/**
 * 获取字典数据列表
 * @param dictType  字典类型
 */
export function getDictDataList(dictType) {
    // console.log(typeAll);
    const type = JSON.parse(localStorage.getItem("type_all")).find((element) => (element.dictType === dictType))
    if (type) {
        return type.dataList
    } else {
        return []
    }
}

/**
 * 获取字典名称
 * @param dictType  字典类型
 * @param dictValue  字典值
 */
export function getDictLabel(dictType, dictValue) {
    const type = JSON.parse(localStorage.getItem("type_all")).find((element) => (element.dictType === dictType))
    if (type) {
        const val = type.dataList.find((element) => (element.dictValue === dictValue + ''))
        if (val) {
            return val.dictLabel
        } else {
            return dictValue
        }
    } else {
        return dictValue
    }
}

/**
 * 获取字典名称
 * @param dictType  字典类型
 * @param dictValue  字典值
 */
export function getDictLabelCydn(dictType, dictValue) {
    const type = JSON.parse(localStorage.getItem("type_all_cydn")).find((element) => (element.dictType === dictType))
    if (type) {
        const val = type.dataList.find((element) => (element.dictValue === dictValue + ''))
        if (val) {
            return val.dictLabel
        } else {
            return dictValue
        }
    } else {
        return dictValue
    }
}

/**
 * 打电话
 * @param phonenumber
 */
export function callPhone(phonenumber) {
    window.location.href = 'tel://' + phonenumber
}

/**
 * 判断是否为一个整数
 * @param {object} obj 字符串
 * @return {boolean} true/false
 */
export function isInteger(obj) {
    return Math.floor(obj) === obj;
}

/**
 * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
 * @param {object} floatNum 小数
 * @return {object} {times:100, num: 314}
 */
export function toInteger(floatNum) {
    var ret = {times: 1, num: 0}
    var isNegative = floatNum < 0
    if (isInteger(floatNum)) {
        ret.num = floatNum
        return ret
    }
    var strfi = floatNum + ''
    var dotPos = strfi.indexOf('.')
    var len = strfi.substr(dotPos + 1).length
    var times = Math.pow(10, len)
    var intNum = parseInt(Math.abs(floatNum) * times + 0.5, 10)
    ret.times = times
    if (isNegative) {
        intNum = -intNum
    }
    ret.num = intNum
    return ret
}

/**
 * 浮点型数字运算精度丢失修复
 * @param {object} num 小数
 * @param {number} s 小数位数
 * @return {object} s位小数
 */
export function toFixed(num, s) {
    var times = Math.pow(10, s);
    var des = num * times + 0.5;
    des = (parseInt(des, 10) / times) + '';

    var pos_decimal = des.indexOf('.');
    if (pos_decimal > 0) {
        while (des.length <= pos_decimal + s) {
            des += '0';
        }
    }

    return des;
}

/**
 * 浮点型数字运算精度丢失修复
 * 核心方法，实现加减乘除运算，确保不丢失精度
 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @param dig {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
 * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
 * @return {object} dig位小数
 */
function operation(a, b, dig, op) {
    var o1 = toInteger(a)
    var o2 = toInteger(b)
    var n1 = o1.num
    var n2 = o2.num
    var t1 = o1.times
    var t2 = o2.times
    var max = t1 > t2 ? t1 : t2
    var result = null
    switch (op) {
        case 'add':
            if (t1 === t2) { // 两个小数位数相同
                result = n1 + n2
            } else if (t1 > t2) { // o1 小数位 大于 o2
                result = n1 + n2 * (t1 / t2)
            } else { // o1 小数位 小于 o2
                result = n1 * (t2 / t1) + n2
            }
            return toFixed(result / max, dig)
        case 'subtract':
            if (t1 === t2) {
                result = n1 - n2
            } else if (t1 > t2) {
                result = n1 - n2 * (t1 / t2)
            } else {
                result = n1 * (t2 / t1) - n2
            }
            return toFixed(result / max, dig)
        case 'multiply':
            result = (n1 * n2) / (t1 * t2)
            return toFixed(result, dig)
        case 'divide':
            if (n2 === 0)
                result = 0
            else
                result = (n1 / n2) * (t2 / t1)
            return toFixed(result, dig)
    }
}

/**
 * 加法
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @return {object} s位小数
 */
export function add(a, b, s) {
    return operation(a, b, (s | 2), 'add')
}

/**
 * 减法
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @return {object} s位小数
 */
export function subtract(a, b, s) {
    return operation(a, b, (s | 2), 'subtract')
}

/**
 * 乘法
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @return {object} s位小数
 */
export function multiply(a, b, s) {
    return operation(a, b, (s | 2), 'multiply')
}

/**
 * 除法
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @return {object} s位小数
 */
export function divide(a, b, s) {
    return operation(a, b, (s | 2), 'divide')
}

//	计算两点之间直线距离
export function algorithm(point1, point2) {
    let [x1, y1] = point1;
    let [x2, y2] = point2;
    let Lat1 = rad(y1); // 纬度
    let Lat2 = rad(y2);
    let a = Lat1 - Lat2;//	两点纬度之差
    let b = rad(x1) - rad(x2); //	经度之差
    let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2)
        + Math.cos(Lat1) * Math.cos(Lat2) * Math.pow(Math.sin(b / 2), 2)));
    //	计算两点距离的公式
    s = s * 6378137.0;//	弧长等于弧度乘地球半径（半径为米）
    s = Math.round(s * 10000) / 10000;//	精确距离的数值
    s = s.toFixed(2)

    // 转化
    if (isEmptyStr(s)) {
        return '-- m';
    }
    var formattedNumber;
    if (s >= 1000) {
        formattedNumber = (s / 1000).toFixed(2) + ' km';
    } else {
        formattedNumber = s + ' m';
    }

    return formattedNumber;

}

//	角度转换成弧度
export function rad(d) {
    return d * Math.PI / 180.00;
}

export function commonLogOut() {
    localStorage.removeItem("userInfo");
    // 清除cookie
    Cookies.remove('jk_community_token')
    // 融云 移除监听
    const Events = RongIMLib.Events
    // 移除具体事件的所有监听器
    RongIMLib.removeEventListeners(Events.MESSAGES)
}

// 2、在项目中引入：
import JSEncrypt from 'jsencrypt'
import {parseBigInt} from "jsencrypt/lib/lib/jsbn/jsbn";

// 3、加密（origin：原始text，key：公钥）
export function encryptMI(origin, key) {
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(key)
    return encrypt.encrypt(origin)
}


// 4、解密（origin：加密text，key：私钥）
export function decryptMI(cipher) {
    // const decrypt = new JSEncrypt()
    // decrypt.setPublicKey(decryptStr)
    // decrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + decryptStr + '-----END PUBLIC KEY-----')
    // return decryptMy(cipher, decryptStr)
}

export const decryptStr = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+B3uQOs3+YRrpE0HOEfHhUt6eJe0SjgQ5lyTd40qbVX7RXOZ7s04x3NxeMgAecym/Y0BbopGf/3hx+pClCLYKEMqjVDHLwoA0oRmb/WD1vVb+zPdhUNrhvVomI8se1XMvbjYWqbsoOvAl6PekxJq6S9GN6cAtF9Ujoh+J9luR9wIDAQAB'

export function decryptMy(data, publicKey) {
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(publicKey)
    // 不支持公钥解密
    // 自定义解析方法支持公钥解析
    const rsaKey = encrypt.getKey()
    rsaKey.decrypt = function (ctext) {
        var c = parseBigInt(ctext, 16)
        var m = this.doPublic(c)
        if (m == null) {
            return null
        }
        return pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3)
    }
    return encrypt.decrypt(data)
}

export function pkcs1unpad2(d, n) {
    var b = d.toByteArray()
    var i = 0
    while (i < b.length && b[i] === 0) {
        ++i
    }
    // if (b.length - i !== n - 1 || b[i] !== 2) {
    //   return null
    // }
    ++i
    while (b[i] !== 0) {
        if (++i >= b.length) {
            return null
        }
    }
    var ret = ''
    while (++i < b.length) {
        var c = b[i] & 255
        if (c < 128) { // utf-8 decode
            ret += String.fromCharCode(c)
        } else if ((c > 191) && (c < 224)) {
            ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63))
            ++i
        } else {
            ret += String.fromCharCode(((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63))
            i += 2
        }
    }
    return ret
}

class JsEncryptNew extends JSEncrypt {
    constructor() {
        super();
        this.b64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        this.b64pad = '=';
        this.BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
    }

    int2char = function (n) {
        return this.BI_RM.charAt(n);
    };
    b64tohex = function (s) {
        var ret = '';
        var i;
        var k = 0; // b64 state, 0-3
        var slop = 0;
        for (i = 0; i < s.length; ++i) {
            if (s.charAt(i) === this.b64pad) {
                break;
            }
            var v = this.b64map.indexOf(s.charAt(i));
            if (v < 0) {
                continue;
            }
            if (k === 0) {
                ret += this.int2char(v >> 2);
                slop = v & 3;
                k = 1;
            } else if (k === 1) {
                ret += this.int2char((slop << 2) | (v >> 4));
                slop = v & 0xf;
                k = 2;
            } else if (k === 2) {
                ret += this.int2char(slop);
                ret += this.int2char(v >> 2);
                slop = v & 3;
                k = 3;
            } else {
                ret += this.int2char((slop << 2) | (v >> 4));
                ret += this.int2char(v & 0xf);
                k = 0;
            }
        }
        if (k === 1) {
            ret += this.int2char(slop << 2);
        }
        return ret;
    };
    hex2b64 = function (h) {
        var i;
        var c;
        var ret = '';
        for (i = 0; i + 3 <= h.length; i += 3) {
            c = parseInt(h.substring(i, i + 3), 16);
            ret += this.b64map.charAt(c >> 6) + this.b64map.charAt(c & 63);
        }
        if (i + 1 === h.length) {
            c = parseInt(h.substring(i, i + 1), 16);
            ret += this.b64map.charAt(c << 2);
        } else if (i + 2 === h.length) {
            c = parseInt(h.substring(i, i + 2), 16);
            ret += this.b64map.charAt(c >> 2) + this.b64map.charAt((c & 3) << 4);
        }
        while ((ret.length & 3) > 0) {
            ret += this.b64pad;
        }
        return ret;
    };
    // 分段加密
    encryptLong = function (string) {
        var k = this.getKey();
        // var maxLength = (((k.n.bitLength() + 7) >> 3) - 11);//117
        try {
            // var lt = '';
            var ct = '';
            // RSA每次加密117bytes，需要辅助方法判断字符串截取位置
            // 1.获取字符串截取点
            var bytes = [];
            bytes.push(0);
            var byteNo = 0;
            var len, c;
            len = string.length;
            var temp = 0;
            for (var i = 0; i < len; i++) {
                c = string.charCodeAt(i);
                if (c >= 0x010000 && c <= 0x10FFFF) {
                    byteNo += 4;
                } else if (c >= 0x000800 && c <= 0x00FFFF) {
                    byteNo += 3;
                } else if (c >= 0x000080 && c <= 0x0007FF) {
                    byteNo += 2;
                } else {
                    byteNo += 1;
                }
                if ((byteNo % 117) >= 114 || (byteNo % 117) === 0) {
                    if (byteNo - temp >= 114) {
                        bytes.push(i);
                        temp = byteNo;
                    }
                }
            }
            // 2.截取字符串并分段加密
            if (bytes.length > 1) {
                for (let i = 0; i < bytes.length - 1; i++) {
                    var str;
                    if (i === 0) {
                        str = string.substring(0, bytes[i + 1] + 1);
                    } else {
                        str = string.substring(bytes[i] + 1, bytes[i + 1] + 1);
                    }
                    var t1 = k.encrypt(str);
                    ct += t1;
                }

                if (bytes[bytes.length - 1] !== string.length - 1) {
                    var lastStr = string.substring(bytes[bytes.length - 1] + 1);
                    ct += k.encrypt(lastStr);
                    // debugger;
                }
                return this.hex2b64(ct);
            }
            var t = k.encrypt(string);
            var y = this.hex2b64(t);
            return y;

        } catch (ex) {
            return false;
        }
    };
    // 分段解密长字符串
    decryptLong = function (text) {
        // Return the decrypted string.
        // console.log(this);
        var k = this.getKey();
        var maxLength = ((k.n.bitLength() + 7) >> 3);
        // var maxLength = 128;
        try {
            var str = this.b64tohex(text);
            // var b=hex2Bytes(str);

            var inputLen = str.length;

            var ct = '';

            if (inputLen > maxLength) {

                var lt = str.match(/.{1,256}/g);
                lt.forEach(function (entry) {
                    var t1 = k.decrypt(entry);
                    ct += t1;
                });
                return ct;
            }
            var y = k.decrypt(this.b64tohex(text));
            return y;
        } catch (ex) {
            return false;
        }
    };
}

/**
 * 权限
 * @param {*} key
 */
export function hasPermission(key) {
    return window.SITE_CONFIG['permissions'].indexOf(key) !== -1 || false
}

/**
 * 获取uuid
 */
export function getUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
    })
}

/**
 * 获取svg图标(id)列表
 */
export function getIconList() {
    var res = []
    var list = document.querySelectorAll('svg symbol')
    for (var i = 0; i < list.length; i++) {
        res.push(list[i].id)
    }

    return res
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'id', pid = 'pid') {
    var res = []
    var temp = {}
    for (var i = 0; i < data.length; i++) {
        temp[data[i][id]] = data[i]
    }
    for (var k = 0; k < data.length; k++) {
        if (!temp[data[k][pid]] || data[k][id] === data[k][pid]) {
            res.push(data[k])
            continue
        }
        if (!temp[data[k][pid]]['children']) {
            temp[data[k][pid]]['children'] = []
        }
        temp[data[k][pid]]['children'].push(data[k])
        data[k]['_level'] = (temp[data[k][pid]]._level || 0) + 1
    }
    return res
}

// 获取URL查询参数
export function getQueryVariable(variable) {
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}

//将base64转换为blob
export function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = window.atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    console.log(arr[0].match(/:(.*?);/));

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    });
}

//将blob转换为file
export function blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}

// 对象数组去重 利用对象key值不能重复的特点
/* @dataArray  要去重的对象数组
 ** @key 对象中唯一不重复的键值
 */
export function unique(dataArray, key) {
    let result = {}
    let finalArr = []
    for (const i in dataArray) {
        result[dataArray[i][key]] = dataArray[i]
    }
    // 把result对象的value值转为数组
    for (const item in result) {
        finalArr.push(result[item])
    }
    return finalArr
}

/*
  *将某个数组元素置顶*
  @arr 数组
  @index 指定元素
*/
export function toFirst(arr, index) {
    if (index > 0) { //第一个元素和index为负数的元素不置顶
        arr.unshift(arr.splice(index, 1)[0])
    }
}

export function extractPathFromUrl(url) {
    const pattern = /http:\/\/\d+\.\d+\.\d+\.\d+:\d+(.*)/;
    const match = url.match(pattern);

    if (match) {
        return match[1]; // 返回匹配的路径部分
    }
    return url; // 如果未匹配，返回原始 URL
}

export function openNoticeFile(url) {
    jWeixin.miniProgram.navigateTo({url: '/pages/open-file/openFile?filePath=' + url})
}

export function getCydnToken() {
    let mParams = {
        username: 'admin',
        // password: '8d69aabc2f4ad9e56228348eec548ce3',
        password: '8d69aabc2f4ad9e56228348eec548ce3',
        grant_type: 'password',
        tenantId: '000000',
    }
    axios
        .post('/cydn/blade-auth/oauth/token?' + qs.stringify(mParams), {}, {
            headers: {
                Authorization: 'Basic c2FiZXI6c2FiZXJfc2VjcmV0',
            }
        })
        .then(({data: res}) => {
            console.log(res, '---->')
            localStorage.setItem('cydn_token', res.access_token)
            store.state.cydnToken = res.access_token

            Vue.prototype.$cydnToken = res.access_token
        })
        .catch((err) => {
            console.log(err);
        });
}

export function statisticsModules(miniModuleName) {

    let mParams = {
        moduleName: miniModuleName,
        userId: store.state.user.userInfo.id,
        userName: store.state.user.userInfo.realName,
    }

    axios
        .post('/cydn/blade-zajk/module/add', mParams, {
            headers: {
                'Authorization': 'Basic c2FiZXI6c2FiZXJfc2VjcmV0',
                'Blade-Auth': 'Bearer ' + Vue.prototype.$cydnToken,
            }
        })
        .then(({data: res}) => {
            console.log(res, '---->')
        })
        .catch((err) => {
            console.log(err);
        });
}

export function statisticsPolicy(policyType, policyId) {

    let mParams = {
        userId: store.state.user.userInfo.id,
        userName: store.state.user.userInfo.realName,
        type: policyType,
        policyId: policyId,
    }

    axios
        .post('/cydn/blade-zajk/policy/add', mParams, {
            headers: {
                'Authorization': 'Basic c2FiZXI6c2FiZXJfc2VjcmV0',
                'Blade-Auth': 'Bearer ' + Vue.prototype.$cydnToken,
            }
        })
        .then(({data: res}) => {
            console.log(res, '---->')
        })
        .catch((err) => {
            console.log(err);
        });
}

export function isAdminAccount() {
    if (
        store.state.user.userInfo.mobile=='13014618854' || // dongya
        store.state.user.userInfo.mobile=='19522326696' || // kaihua
        store.state.user.userInfo.mobile=='19903808297' || // shuisen
        // store.state.user.userInfo.mobile=='13298108272' ||

        store.state.user.userInfo.mobile === '15736756691' ||
        store.state.user.userInfo.mobile === '18939670466' ||
        store.state.user.userInfo.mobile === '15838108102' ||
        store.state.user.userInfo.mobile === '13523572793'
    ) {
        return true
    } else {
        return false
    }
}
